/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTokenCreateClientRulesGet } from '../fn/api-token/api-token-create-client-rules-get';
import { ApiTokenCreateClientRulesGet$Params } from '../fn/api-token/api-token-create-client-rules-get';
import { apiTokenCreateClientRulesPost } from '../fn/api-token/api-token-create-client-rules-post';
import { ApiTokenCreateClientRulesPost$Params } from '../fn/api-token/api-token-create-client-rules-post';
import { apiTokenCreateGet } from '../fn/api-token/api-token-create-get';
import { ApiTokenCreateGet$Params } from '../fn/api-token/api-token-create-get';
import { apiTokenCreateIpRulesGet } from '../fn/api-token/api-token-create-ip-rules-get';
import { ApiTokenCreateIpRulesGet$Params } from '../fn/api-token/api-token-create-ip-rules-get';
import { apiTokenCreateIpRulesPost } from '../fn/api-token/api-token-create-ip-rules-post';
import { ApiTokenCreateIpRulesPost$Params } from '../fn/api-token/api-token-create-ip-rules-post';
import { apiTokenCreatePost } from '../fn/api-token/api-token-create-post';
import { ApiTokenCreatePost$Params } from '../fn/api-token/api-token-create-post';
import { apiTokenDelete } from '../fn/api-token/api-token-delete';
import { ApiTokenDelete$Params } from '../fn/api-token/api-token-delete';
import { apiTokenGetAllIpRules } from '../fn/api-token/api-token-get-all-ip-rules';
import { ApiTokenGetAllIpRules$Params } from '../fn/api-token/api-token-get-all-ip-rules';
import { apiTokenGetApis } from '../fn/api-token/api-token-get-apis';
import { ApiTokenGetApis$Params } from '../fn/api-token/api-token-get-apis';
import { apiTokenGetApiTokenById } from '../fn/api-token/api-token-get-api-token-by-id';
import { ApiTokenGetApiTokenById$Params } from '../fn/api-token/api-token-get-api-token-by-id';
import { apiTokenGetApiTokensAudit } from '../fn/api-token/api-token-get-api-tokens-audit';
import { ApiTokenGetApiTokensAudit$Params } from '../fn/api-token/api-token-get-api-tokens-audit';
import { apiTokenGetApiTokensWithPagination } from '../fn/api-token/api-token-get-api-tokens-with-pagination';
import { ApiTokenGetApiTokensWithPagination$Params } from '../fn/api-token/api-token-get-api-tokens-with-pagination';
import { apiTokenGetClientRulesById } from '../fn/api-token/api-token-get-client-rules-by-id';
import { ApiTokenGetClientRulesById$Params } from '../fn/api-token/api-token-get-client-rules-by-id';
import { apiTokenGetIpRulesById } from '../fn/api-token/api-token-get-ip-rules-by-id';
import { ApiTokenGetIpRulesById$Params } from '../fn/api-token/api-token-get-ip-rules-by-id';
import { apiTokenUpdateApiTokenIp } from '../fn/api-token/api-token-update-api-token-ip';
import { ApiTokenUpdateApiTokenIp$Params } from '../fn/api-token/api-token-update-api-token-ip';
import { apiTokenUpdateClientRulesGet } from '../fn/api-token/api-token-update-client-rules-get';
import { ApiTokenUpdateClientRulesGet$Params } from '../fn/api-token/api-token-update-client-rules-get';
import { apiTokenUpdateClientRulesPost } from '../fn/api-token/api-token-update-client-rules-post';
import { ApiTokenUpdateClientRulesPost$Params } from '../fn/api-token/api-token-update-client-rules-post';
import { apiTokenUpdateIpRulesGet } from '../fn/api-token/api-token-update-ip-rules-get';
import { ApiTokenUpdateIpRulesGet$Params } from '../fn/api-token/api-token-update-ip-rules-get';
import { apiTokenUpdateIpRulesPost } from '../fn/api-token/api-token-update-ip-rules-post';
import { ApiTokenUpdateIpRulesPost$Params } from '../fn/api-token/api-token-update-ip-rules-post';
import { apiTokenUpdateStatus } from '../fn/api-token/api-token-update-status';
import { ApiTokenUpdateStatus$Params } from '../fn/api-token/api-token-update-status';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfDictionaryOfStringAndString } from '../models/custom-result-of-dictionary-of-string-and-string';
import { CustomResultOfGetApiTokenByIdDto } from '../models/custom-result-of-get-api-token-by-id-dto';
import { CustomResultOfGetRulesByClientDto } from '../models/custom-result-of-get-rules-by-client-dto';
import { CustomResultOfGetRulesByIpDto } from '../models/custom-result-of-get-rules-by-ip-dto';
import { CustomResultOfListOfSetIpRateLimitRuleRequest } from '../models/custom-result-of-list-of-set-ip-rate-limit-rule-request';
import { CustomResultOfPaginatedListOfGetApiTokensWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-api-tokens-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ApiTokenService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTokenGetApiTokensAudit()` */
  static readonly ApiTokenGetApiTokensAuditPath = '/ApiToken/GetApiTokensAudit';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetApiTokensAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenGetApiTokensAudit$Response(params: ApiTokenGetApiTokensAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return apiTokenGetApiTokensAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetApiTokensAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenGetApiTokensAudit(params: ApiTokenGetApiTokensAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.apiTokenGetApiTokensAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `apiTokenGetApiTokensWithPagination()` */
  static readonly ApiTokenGetApiTokensWithPaginationPath = '/ApiToken/GetApiTokensWithPagination';

  /**
   * For each user get ApiTokens with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetApiTokensWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenGetApiTokensWithPagination$Response(params: ApiTokenGetApiTokensWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetApiTokensWithPaginationDto>> {
    return apiTokenGetApiTokensWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get ApiTokens with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetApiTokensWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenGetApiTokensWithPagination(params: ApiTokenGetApiTokensWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetApiTokensWithPaginationDto> {
    return this.apiTokenGetApiTokensWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetApiTokensWithPaginationDto>): CustomResultOfPaginatedListOfGetApiTokensWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateStatus()` */
  static readonly ApiTokenUpdateStatusPath = '/ApiToken/UpdateStatus';

  /**
   * Update ApiToken Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateStatus$Response(params: ApiTokenUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ApiToken Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateStatus(params: ApiTokenUpdateStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateApiTokenIp()` */
  static readonly ApiTokenUpdateApiTokenIpPath = '/ApiToken/UpdateApiTokenIp';

  /**
   * به روز رسانی آی پی توکن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateApiTokenIp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateApiTokenIp$Response(params: ApiTokenUpdateApiTokenIp$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenUpdateApiTokenIp(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی آی پی توکن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateApiTokenIp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateApiTokenIp(params: ApiTokenUpdateApiTokenIp$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenUpdateApiTokenIp$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenGetApiTokenById()` */
  static readonly ApiTokenGetApiTokenByIdPath = '/ApiToken/GetApiTokenById';

  /**
   * Get ApiToken by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetApiTokenById()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetApiTokenById$Response(params?: ApiTokenGetApiTokenById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetApiTokenByIdDto>> {
    return apiTokenGetApiTokenById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ApiToken by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetApiTokenById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetApiTokenById(params?: ApiTokenGetApiTokenById$Params, context?: HttpContext): Observable<CustomResultOfGetApiTokenByIdDto> {
    return this.apiTokenGetApiTokenById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetApiTokenByIdDto>): CustomResultOfGetApiTokenByIdDto => r.body)
    );
  }

  /** Path part for operation `apiTokenCreateIpRulesGet()` */
  static readonly ApiTokenCreateIpRulesGetPath = '/ApiToken/CreateIpRules';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreateIpRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateIpRulesGet$Response(params?: ApiTokenCreateIpRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiTokenCreateIpRulesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreateIpRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateIpRulesGet(params?: ApiTokenCreateIpRulesGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiTokenCreateIpRulesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiTokenCreateIpRulesPost()` */
  static readonly ApiTokenCreateIpRulesPostPath = '/ApiToken/CreateIpRules';

  /**
   * Create IpRules.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreateIpRulesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreateIpRulesPost$Response(params: ApiTokenCreateIpRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenCreateIpRulesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create IpRules.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreateIpRulesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreateIpRulesPost(params: ApiTokenCreateIpRulesPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenCreateIpRulesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateIpRulesGet()` */
  static readonly ApiTokenUpdateIpRulesGetPath = '/ApiToken/UpdateIpRules';

  /**
   * Get Rules By Ip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateIpRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenUpdateIpRulesGet$Response(params?: ApiTokenUpdateIpRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetRulesByIpDto>> {
    return apiTokenUpdateIpRulesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Rules By Ip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateIpRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenUpdateIpRulesGet(params?: ApiTokenUpdateIpRulesGet$Params, context?: HttpContext): Observable<CustomResultOfGetRulesByIpDto> {
    return this.apiTokenUpdateIpRulesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetRulesByIpDto>): CustomResultOfGetRulesByIpDto => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateIpRulesPost()` */
  static readonly ApiTokenUpdateIpRulesPostPath = '/ApiToken/UpdateIpRules';

  /**
   * در صفحه ای که تمام رول های آی پی هر سطر را می بینه، آی پی تمام رول ها پاک میشه و رول های جدید ورودی جایگزین میشه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateIpRulesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateIpRulesPost$Response(params: ApiTokenUpdateIpRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenUpdateIpRulesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * در صفحه ای که تمام رول های آی پی هر سطر را می بینه، آی پی تمام رول ها پاک میشه و رول های جدید ورودی جایگزین میشه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateIpRulesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateIpRulesPost(params: ApiTokenUpdateIpRulesPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenUpdateIpRulesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenGetIpRulesById()` */
  static readonly ApiTokenGetIpRulesByIdPath = '/ApiToken/GetIpRulesById';

  /**
   * Get Rules By Ip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetIpRulesById()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetIpRulesById$Response(params?: ApiTokenGetIpRulesById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetRulesByIpDto>> {
    return apiTokenGetIpRulesById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Rules By Ip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetIpRulesById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetIpRulesById(params?: ApiTokenGetIpRulesById$Params, context?: HttpContext): Observable<CustomResultOfGetRulesByIpDto> {
    return this.apiTokenGetIpRulesById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetRulesByIpDto>): CustomResultOfGetRulesByIpDto => r.body)
    );
  }

  /** Path part for operation `apiTokenGetApis()` */
  static readonly ApiTokenGetApisPath = '/ApiToken/GetApis';

  /**
   * Get All Apis.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetApis()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetApis$Response(params?: ApiTokenGetApis$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfDictionaryOfStringAndString>> {
    return apiTokenGetApis(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Apis.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetApis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetApis(params?: ApiTokenGetApis$Params, context?: HttpContext): Observable<CustomResultOfDictionaryOfStringAndString> {
    return this.apiTokenGetApis$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfDictionaryOfStringAndString>): CustomResultOfDictionaryOfStringAndString => r.body)
    );
  }

  /** Path part for operation `apiTokenGetAllIpRules()` */
  static readonly ApiTokenGetAllIpRulesPath = '/ApiToken/GetAllIpRules';

  /**
   * Get All Ip Rules.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetAllIpRules()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetAllIpRules$Response(params?: ApiTokenGetAllIpRules$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSetIpRateLimitRuleRequest>> {
    return apiTokenGetAllIpRules(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Ip Rules.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetAllIpRules$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetAllIpRules(params?: ApiTokenGetAllIpRules$Params, context?: HttpContext): Observable<CustomResultOfListOfSetIpRateLimitRuleRequest> {
    return this.apiTokenGetAllIpRules$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSetIpRateLimitRuleRequest>): CustomResultOfListOfSetIpRateLimitRuleRequest => r.body)
    );
  }

  /** Path part for operation `apiTokenCreateClientRulesGet()` */
  static readonly ApiTokenCreateClientRulesGetPath = '/ApiToken/CreateClientRules';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreateClientRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateClientRulesGet$Response(params?: ApiTokenCreateClientRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiTokenCreateClientRulesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreateClientRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateClientRulesGet(params?: ApiTokenCreateClientRulesGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiTokenCreateClientRulesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiTokenCreateClientRulesPost()` */
  static readonly ApiTokenCreateClientRulesPostPath = '/ApiToken/CreateClientRules';

  /**
   * Create Client Rules.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreateClientRulesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreateClientRulesPost$Response(params: ApiTokenCreateClientRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenCreateClientRulesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Client Rules.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreateClientRulesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreateClientRulesPost(params: ApiTokenCreateClientRulesPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenCreateClientRulesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateClientRulesGet()` */
  static readonly ApiTokenUpdateClientRulesGetPath = '/ApiToken/UpdateClientRules';

  /**
   * Get Rules By Client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateClientRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenUpdateClientRulesGet$Response(params?: ApiTokenUpdateClientRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetRulesByClientDto>> {
    return apiTokenUpdateClientRulesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Rules By Client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateClientRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenUpdateClientRulesGet(params?: ApiTokenUpdateClientRulesGet$Params, context?: HttpContext): Observable<CustomResultOfGetRulesByClientDto> {
    return this.apiTokenUpdateClientRulesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetRulesByClientDto>): CustomResultOfGetRulesByClientDto => r.body)
    );
  }

  /** Path part for operation `apiTokenUpdateClientRulesPost()` */
  static readonly ApiTokenUpdateClientRulesPostPath = '/ApiToken/UpdateClientRules';

  /**
   * در صفحه ای که تمام رول های کلاینت هر سطر را می بینه، آی پی تمام رول ها پاک میشه و رول های جدید ورودی جایگزین میشه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenUpdateClientRulesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateClientRulesPost$Response(params: ApiTokenUpdateClientRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenUpdateClientRulesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * در صفحه ای که تمام رول های کلاینت هر سطر را می بینه، آی پی تمام رول ها پاک میشه و رول های جدید ورودی جایگزین میشه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenUpdateClientRulesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenUpdateClientRulesPost(params: ApiTokenUpdateClientRulesPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenUpdateClientRulesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenGetClientRulesById()` */
  static readonly ApiTokenGetClientRulesByIdPath = '/ApiToken/GetClientRulesById';

  /**
   * Get Rules By Client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenGetClientRulesById()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetClientRulesById$Response(params?: ApiTokenGetClientRulesById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetRulesByClientDto>> {
    return apiTokenGetClientRulesById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Rules By Client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenGetClientRulesById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenGetClientRulesById(params?: ApiTokenGetClientRulesById$Params, context?: HttpContext): Observable<CustomResultOfGetRulesByClientDto> {
    return this.apiTokenGetClientRulesById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetRulesByClientDto>): CustomResultOfGetRulesByClientDto => r.body)
    );
  }

  /** Path part for operation `apiTokenCreateGet()` */
  static readonly ApiTokenCreateGetPath = '/ApiToken/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateGet$Response(params?: ApiTokenCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiTokenCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenCreateGet(params?: ApiTokenCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiTokenCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiTokenCreatePost()` */
  static readonly ApiTokenCreatePostPath = '/ApiToken/Create';

  /**
   * Create ApiToken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreatePost$Response(params: ApiTokenCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ApiToken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiTokenCreatePost(params: ApiTokenCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `apiTokenDelete()` */
  static readonly ApiTokenDeletePath = '/ApiToken/{id}';

  /**
   * Delete ApiToken.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTokenDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenDelete$Response(params: ApiTokenDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return apiTokenDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ApiToken.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTokenDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTokenDelete(params: ApiTokenDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.apiTokenDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
